import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=375ad30a&scoped=true"
import script from "./classify.vue?vue&type=script&lang=js"
export * from "./classify.vue?vue&type=script&lang=js"
import style0 from "./classify.vue?vue&type=style&index=0&id=375ad30a&prod&lang=scss&scoped=true"
import style1 from "./classify.vue?vue&type=style&index=1&id=375ad30a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ad30a",
  null
  
)

export default component.exports